import { ArticleParagraph2 } from '@cian/ui-kit';

import { type FC, type PropsWithChildren } from 'react';

import styles from './Tag.css';

type TagProps = {
  handleClose: VoidFunction;
  testId?: string;
};

export const Tag: FC<PropsWithChildren<TagProps>> = props => {
  const { handleClose, children, testId } = props;

  return (
    <div className={styles['tag']} data-testid={testId}>
      <ArticleParagraph2 color="white_100">{children}</ArticleParagraph2>
      <button className={styles['button']} onClick={handleClose} />
    </div>
  );
};
